export default __webpack_public_path__ + "static/media/topship-origin.59b70a42.png";